/**
 * Central place for the TrigoTour support contact so a phone-number change
 * only requires updating this file. Digits-only format (WhatsApp requirement).
 */
export const SUPPORT_PHONE = "237670738113"; // +237 670 738 113
export const SUPPORT_WHATSAPP_URL = (message = "Bonjour TrigoTour") =>
  `https://wa.me/${SUPPORT_PHONE}?text=${encodeURIComponent(message)}`;
